import { AppRouteProps } from "@harea/component";
import { ProjectDayOffCreateRoutes } from "../create/ProjectDayOffCreateRoutes";
import DayoffMissingDetailscontainer from "./container/DayoffMissingDetailscontainer";
import { DetailsLayout } from "./components/DetailsLayout";

export const DayoffMissingDetailsRoutes: Array<AppRouteProps> = [
    {
        path: ":id",
        title: "{{TimeOffTitle}}",
        element: <DetailsLayout />,
        roles: ["TIMEOFF"],
        children: [
            {
                path: '',
                element: <DayoffMissingDetailscontainer />
            },
            ...ProjectDayOffCreateRoutes
        ]
    },
];
